import React from 'react'
import './PagePropiedades.css'
import Propiedades from '../../Components/Propiedades/Propiedades'
export default function PagePropiedades() {
    return (
        <div>
            <Propiedades />
        </div>
    )
}
